import { PropsWithChildren } from 'react';
import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface"
import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import Helper from 'Interfaces/Helper';
import ComponentImage from "GeneralComponents/ComponentImage";

interface Props extends PropsWithChildren {
    componentId: string;
    contentShowItem: CarouselItem;
    collapseId: string;
    onCardClick: (e: any) => void;
    isSelected: boolean;
    linkTarget?: string;
}

const MobileCard = ({ componentId, contentShowItem, collapseId, isSelected, onCardClick, children, linkTarget }: Props) => {

    const dir = getComputedStyle(document.documentElement).direction;

    return (
        <div className="card-header mst-circlesItem-header" id={componentId + "-heading-" + contentShowItem.index} tabIndex={0}>

            <div className="mb-0 mst-circlesItem-header-contents text-center">

                {
                    !!contentShowItem.content ?

                        <button
                            className="btn btn-link btn-block mst-circlesItem-header-top"
                            type="button" data-bs-toggle="collapse"
                            data-bs-target={"#" + collapseId}
                            aria-expanded={isSelected}
                            aria-controls={collapseId}
                            onClick={onCardClick}>

                            {children}

                        </button>
                        :
                        <div className="mst-circlesItem-header-top">

                            {children}

                            {
                                (contentShowItem.link.url || contentShowItem.url) &&
                                <CustomLinkButton
                                    title={contentShowItem.title}
                                    pageUrl={contentShowItem.url}
                                    link={contentShowItem.link}
                                    isBtn={false}
                                    linkClass="mst-overlay-link"
                                    dir={dir}
                                    linkTarget={linkTarget}
                                />
                            }
                        </div>
                }

            </div>

        </div>
    )
}

MobileCard.Content = ({ contentShowItem }: { contentShowItem: CarouselItem;  }) => {
    const hasContent = !!contentShowItem.content;
    const isRtl = getComputedStyle(document.documentElement).direction == 'rtl';
    const isLink = !hasContent && (checkIsLink(contentShowItem.link.url) || checkIsLink(contentShowItem.url));

    function checkIsLink(url: string) {
        const urlInitials = ["/", "http", "tel:"];
        return urlInitials.some(init => url.startsWith(init));
    }

    return (
        <>
            {
                contentShowItem.image &&
                <ComponentImage
                    image={contentShowItem.image}
                    imageClass=""
                    mobileImage={contentShowItem.mobileImage}
                    mobileImageClass=""
                    wrapperDivClass="mst-circlesItem-Img"
                    cropAlias="squareImage"
                />
            }
            <div className="mst-circlesItem-Title regular-txt mb-1" >
                <div className={`${isLink || hasContent ? "tab-has-link" : ""}`}>
                    <span>{contentShowItem.title} </span>
                    {
                        (isLink || hasContent) &&
                        <span className="mst-arrow"><i className={`fa fa-fw fa-chevron-${isRtl? 'left': 'right'} `} aria-hidden="true"></i></span>
                    }
                </div>
            </div>
            <span className="mst-circlesItem-shortDesc regular-txt " dangerouslySetInnerHTML={{ __html: contentShowItem.richDescription }}></span>
        </>
    );
}

export default MobileCard;